import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

import { NavButton } from "../Carousel/styles";

export const renderPrevButton = ({
  isDisabled = true,
  handleClick = () => {
    null;
  },
}) => {
  return (
    <NavButton
      style={{ display: isDisabled ? "flex" : "none" }}
      onClick={handleClick}
    >
      <FiChevronLeft size={36} color="#f2f2f2" />
    </NavButton>
  );
};

interface IRenderNextButtonProps {
  handleClick?: () => void;
}

export const renderNextButton = (props: IRenderNextButtonProps) => {
  return (
    <NavButton onClick={props?.handleClick}>
      <FiChevronRight size={36} color="#f2f2f2" />
    </NavButton>
  );
};
